<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to My Attendance Menu" @click="$router.push('/myattendance')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" pageId="timeoff-page" color="white"></help-link>
                    <v-menu left v-model="menu_status" offset-y >
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on">
                                &nbsp;&nbsp;CY {{selectedFiscalYear}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-for="(item,index) in fiscal_years" :key="index" :title="`Calendar Year ${item.fiscalYear}`" @click="setSelectedYear(item.fiscalYear)">
                                <v-list-tile-title small>CY {{item.fiscalYear}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-card>

            <!-- details -->
            <v-card class="elavation-1 mt-5">
                <v-toolbar flat height="45px">
                    <div class="wp-30 mb-10">
                        <v-text-field v-model="search" append-icon="search" label="Search date" single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                        <v-switch
                            v-model="viewAll"
                            label="View all"
                            color="primary"
                            hide-details
                        ></v-switch>
                    </div>
                </v-toolbar>

                <!-- Summary per cutoff -->
                <v-data-table
                    :headers="isMobile?header_mobile:header"
                    :items="timeoffs_summary_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync1"
                    v-show="!viewAll"
                >
                    <template v-slot:items="props">
                        <tr @click="viewCutoffDetails(props.item)" class="clickable" title="Click to view timesheet for this period">
                            <td v-if="isMobile">
                                <span :class="isCurrentPeriod(props.item)?'font-weight-bold':''">
                                    {{ props.item.cutOffStart | moment("MMM DD") }} - {{ props.item.cutOffEnd | moment("DD, YYYY") }}
                                </span>
                            </td>
                            <td v-if="!isMobile">
                                <span :class="isCurrentPeriod(props.item)?'font-weight-bold':''">{{props.item.cutOffPeriodDesc}}</span>
                            </td>
                            <td v-if="!isMobile">{{ props.item.cutOffStart | moment("YYYY-MM-DD") }}</td>
                            <td v-if="!isMobile">{{ props.item.cutOffEnd | moment("YYYY-MM-DD") }}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.cutOffStatus)">{{commonfn.getStatusDescription(props.item.cutOffStatus)}}</b>
                            </td>
                            <td>{{ props.item.timeOffCount }}</td>
                        </tr>
                    </template>
                </v-data-table>

                <!-- View All -->
                <v-data-table
                    :headers="isMobile?headers_all_mobile:headers_all"
                    :items="timeoffs_all_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync2"
                    v-show="viewAll"
                >
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" class="clickable" title="Click to view timesheet for this period">
                            <td>
                                <span v-if="isMobile">{{ props.item.transDate | moment("MMM DD") }}</span>
                                <span v-else>{{ props.item.transDate | moment("YYYY-MM-DD") }}</span>
                            </td>
                            <td>{{ props.item.leaveName }}</td>
                            <td>{{ props.item.hours }}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                            <td v-if="!isMobile">{{ props.item.remarks }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>

            <!-- balances -->
            <v-card class="elavation-1 mt-5">
                <v-toolbar flat height="45px">
                    <b>Leaves Balances (Hours)</b>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" pageId="leave-balances" color="black"></help-link>
                </v-toolbar>
                <v-data-table
                    :headers="isMobile ? [] : header_balances"
                    :items="timeoffs_balances"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync3"
                    :hide-headers="isMobile"
                >
                    <template v-slot:items="props">

                        <!-- mobile view -->
                        <tr v-if="isMobile">
                            <td :colspan="header_balances.length" class="pa-1">
                                <v-card class="elevation-1">
                                    <v-toolbar flat height="42">
                                        <v-chip small class="user-chip-container">
                                            <b>{{ props.item.leaveName }}</b>
                                        </v-chip>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-layout row wrap align-center class="section-layout">
                                        <v-flex xs12 class="text-xs-left mt-5">
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text">Annual Credits</div>
                                                    <div>
                                                        <span v-if="isTimeInLieu(props.item)">NA</span>
                                                        <span v-else>{{props.item.annualAllocationHours==-1? "NA" : numFormat.formatNumber(props.item.annualAllocationHours)}}</span>
                                                    </div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text">Earned</div>
                                                    <div>{{props.item.earnedHours==-1? "NA" : numFormat.formatNumber(props.item.earnedHours)}}</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text">Used</div>
                                                    <div>{{numFormat.formatNumber(props.item.approvedTimeOffHours + props.item.forReviewTimeOffHours)}}</div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text">Balance</div>
                                                    <div>{{props.item.balanceHours==-1? "NA" : numFormat.formatNumber(props.item.balanceHours)}}</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text">Cash Conversion Limit</div>
                                                    <div>
                                                        <span v-if="isTimeInLieu(props.item)">NA</span>
                                                        <span v-else>
                                                            {{props.item.balanceHours==-1? "NA" : props.item.balanceHours>=props.item.convertibleToCashHours? numFormat.formatNumber(props.item.convertibleToCashHours): numFormat.formatNumber(props.item.balanceHours)}}
                                                        </span>
                                                    </div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text">Carry-Over Limit</div>
                                                    <div>
                                                        <span v-if="isTimeInLieu(props.item)">NA</span>
                                                        <span v-else>
                                                            <span v-if="props.item.toCarryOverNextYear==-1">0</span>
                                                            <span v-else>{{ numFormat.formatNumber(props.item.toCarryOverNextYear) }}</span>
                                                        </span>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </td>
                        </tr>

                        <!-- desktop view -->
                        <tr v-else>
                            <td>{{props.item.fiscalYear}}</td>
                            <td>{{props.item.leaveName}}</td>
                            <td>
                                <span v-if="isTimeInLieu(props.item)">NA</span>
                                <span v-else>{{props.item.annualAllocationHours==-1? "NA" : numFormat.formatNumber(props.item.annualAllocationHours)}}</span>
                            </td>
                            <td>{{props.item.earnedHours==-1? "NA" : numFormat.formatNumber(props.item.earnedHours)}}</td>
                            <td>{{numFormat.formatNumber(props.item.approvedTimeOffHours + props.item.forReviewTimeOffHours)}}</td>
                            <td>{{props.item.balanceHours==-1? "NA" : numFormat.formatNumber(props.item.balanceHours)}}</td>
                            <td>
                                <span v-if="isTimeInLieu(props.item)">NA</span>
                                <span v-else>
                                    {{props.item.balanceHours==-1? "NA" : props.item.balanceHours>=props.item.convertibleToCashHours? numFormat.formatNumber(props.item.convertibleToCashHours): numFormat.formatNumber(props.item.balanceHours)}}
                                </span>
                            </td>
                            <td>
                                <span v-if="isTimeInLieu(props.item)">NA</span>
                                <span v-else>
                                    <span v-if="props.item.toCarryOverNextYear==-1">0</span>
                                    <span v-else>{{ numFormat.formatNumber(props.item.toCarryOverNextYear) }}</span>
                                </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>

        </v-flex>
    </v-layout>
</template>

<script>

import timeoffApi from '@/api/timeoffs'
import commonfn from '@/common/functions'               //for refactor
import leavesAllocationApi from '@/api/leavesallocation'
import numFormat from '@/common/num_format'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {
    name: 'Timeoff',
    metaInfo: {
        title: 'Timeoff',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'My Timesheet' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    data () {
        const routeName1 = `${this.$route.name}-table1`
        const routeName2 = `${this.$route.name}-table2`
        const routeName3 = `${this.$route.name}-table3`
        const savedSort1 = userPrefs.getSort(routeName1)
        const savedSort2 = userPrefs.getSort(routeName2)
        const savedSort3 = userPrefs.getSort(routeName3)

        return {
            commonfn,
            numFormat,
            rowsPerPageItems,
            error: false,
            errorMessage: '',
            loading: false,
            paginationSync1: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName1),
                sortBy: savedSort1.sortBy,
                descending: savedSort1.descending,
            },
            paginationSync2: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName2),
                sortBy: savedSort2.sortBy,
                descending: savedSort2.descending,
            },
            paginationSync3: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName3),
                sortBy: savedSort3.sortBy,
                descending: savedSort3.descending,
            },
            viewAll: userPrefs.getViewAllSwitch(this.$route.name),
            selectedFiscalYear: userPrefs.getCalendarYear(this.$route.name),
            search: userPrefs.getSearchKeyword(this.$route.name),
            header_balances: [
                {text: 'Calendar Year',align: 'left',value: 'fiscalYear', width: '5%', sortable:true},
                {text: 'Type',align: 'left',value: 'leaveName', width: '15%', sortable:true},
                {text: 'Annual Credits',align: 'left',value: 'annualAllocationHours', width: '10%', sortable:true},
                {text: 'Earned',align: 'left',value: 'earnedHours', width: '10%', sortable:true},
                {text: 'Used',align: 'left',value: 'approvedTimeOffHours',  width: '10%', sortable:true},
                {text: 'Balance',align: 'left',value: 'balanceHours',  width: '10%', sortable:true},
                {text: 'Cash Conversion Limit',align: 'left',value: 'convertibleToCashHours',  width: '10%', sortable:true},
                {text: 'Carry-Over Limit',align: 'left',value: 'toCarryOverNextYear',  width: '10%', sortable:true},
            ],
            header: [
                {text: 'Period',align: 'left',value: 'cutOffPeriodDesc', width: '10%', sortable:true},
                {text: 'Cutoff Start Date',align: 'left',value: 'cutOffStart', width: '10%', sortable:true},
                {text: 'Cutoff End Date',align: 'left',value: 'cutOffEnd', width: '10%', sortable:true},
                {text: 'Cutoff Status',align: 'left',value: 'cutOffStatus',  width: '10%', sortable:true},
                {text: 'Time Off Items',align: 'left',value: 'timeOffCount',  width: '10%', sortable:true},
            ],
            header_mobile: [
                {text: 'Cutoff Period',align: 'left',value: 'cutOffStart', width: '40%', sortable:true},
                {text: 'Status',align: 'left',value: 'cutOffStatus',  width: '30%', sortable:true},
                {text: 'Items',align: 'left',value: 'timeOffCount',  width: '30%', sortable:true},
            ],
            headers_all: [
                {text: 'Date',align: 'left',value: 'transDate', width:'12%', sortable:true},
                {text: 'Leave Type',align: 'left',value: 'leaveName', width:'40%',sortable:true},
                {text: 'Hours',align: 'left',value: 'hours', width:'12%',sortable:true},
                {text: 'Status',align: 'left',value: 'status', width:'12%',sortable:true},
                {text: 'Remarks',align: 'left',value: '', width:'20%',sortable:false},
            ],
            headers_all_mobile: [
                {text: 'Date',align: 'left',value: 'transDate', width:'20%', sortable:true},
                {text: 'Type',align: 'left',value: 'leaveName', width:'55%',sortable:true},
                {text: 'Hours',align: 'left',value: 'hours', width:'5%',sortable:true},
                {text: 'Status',align: 'left',value: 'status', width:'20%',sortable:true},
            ],
            timeoffs_summary: [],
            timeoffs_balances: [],
            timeoffs_all: [],
            menu_status: false,
        }
    },
    methods: {
        isCurrentPeriod(data){
            return data.cutOffPeriodDesc == 'Current'
        },
        isTimeInLieu(data){
            return data.leaveCode == 'OFFSET'
        },
        setSelectedYear(fiscalYear) {
            this.selectedFiscalYear = fiscalYear
            userPrefs.updateCalendarYear(this.$route.name, fiscalYear)
            this.initialize(false)
        },
        viewCutoffDetails(data) {
            this.$router.push(`timeoff/${data.cutOffId}`)
        },
        viewDetails(data) {
            this.$router.push(`timeoff/details/${data.timeOffId}`)
        },
        async getTimeOffSummary(show_loading) {
            try {
                this.loading = show_loading
                const response = await timeoffApi.getSummary()
                if (response && response.status == 200) {
                    this.timeoffs_summary = response.data.summaryItems
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getBalances() {
            try{
                const response = await leavesAllocationApi.getAvailableByFY(this.selectedFiscalYear)
                if (response && response.status == 200) {
                    this.timeoffs_balances = response.data.items.filter(x => {
                        return x.leaveCode == "VL" || x.leaveCode == "SL" || x.leaveCode == "OFFSET"
                    })
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getAllTimeOffs(show_loading) {
            try{
                this.loading = show_loading
                const response = await timeoffApi.getByFYByUser(this.selectedFiscalYear)
                if (response && response.status == 200) {
                    this.timeoffs_all = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        initialize(show_loading) {
            if (this.viewAll)
                this.getAllTimeOffs(show_loading)
            else
                this.getTimeOffSummary(show_loading)

            this.getBalances()
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: 'My Time Off',
            headerPageTitle: ''
        })

        this.initialize(true)
    },
    watch: {
        'paginationSync1.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-table1`, newVal);
        },
        'paginationSync2.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-table2`, newVal);
        },
        'paginationSync3.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-table3`, newVal);
        },
        'paginationSync1.sortBy'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-table1`, newVal, this.paginationSync1.descending)
        },
        'paginationSync2.sortBy'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-table2`, newVal, this.paginationSync2.descending)
        },
        'paginationSync3.sortBy'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-table3`, newVal, this.paginationSync3.descending)
        },
        'paginationSync1.descending'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-table1`, this.paginationSync1.sortBy, newVal)
        },
        'paginationSync2.descending'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-table2`, this.paginationSync2.sortBy, newVal)
        },
         'paginationSync3.descending'(newVal) {
            userPrefs.updateSort(`${this.$route.name}-table3`, this.paginationSync3.sortBy, newVal)
        },
        viewAll(newVal) {
            userPrefs.updateViewAllSwitch(this.$route.name, newVal)
            this.initialize(false)
        },
        search(newVal) {
            userPrefs.updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        timeoffs_summary_filtered() {
            var temp = this.timeoffs_summary.filter(item => {
                return (item.fiscalYear==this.selectedFiscalYear && !item.cutOffPeriodDesc.includes('Upcoming'))
            })
            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.cutOffStart.includes(this.search))
                })
            }
            return temp //.reverse()
        },
        timeoffs_all_filtered() {
            var temp = this.timeoffs_all

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return (item.transDate.includes(this.search))
                })
            }
            return temp
        },
        fiscal_years() {
            if (this.$store.state.fiscalPeriods) {
                return this.$store.state.fiscalPeriods
            }
            return [{fiscalYear: new Date().getFullYear()}]
        },
        isMobile() {
            return window.innerWidth < 600
        },
    }
}
</script>
<style scoped>
.section-layout {
    padding:0px 23px 0px 23px;
}
</style>